import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/KateMitchell.jpg";

const KateMBio = (props) => {
  const bioData = {
    title: "Kate Mitchell",
    title2: "Independent Director",
    hashName: "kate-mitchell",
    bio1: `Kate Mitchell has served as an independent director of the Company since April 2021. She has also been an advisor to LoanBud and YoAudio since March 2023. Prior to her current roles, Ms. Mitchell served as Executive Vice President, Chief Marketing Officer of Majestic Steel USA from May 2020 until December 2022. Working across marketing, sales, insights, and technology Kate was charged with growing Majestic’s market share, awareness, and nurturing its perception. Prior to joining Majestic Steel, Ms. Mitchell worked as Chief Revenue Officer of Gallery Media Group from August 2018 until March 2020. Throughout her career, Ms. Mitchell worked with some of the largest brands in the media sector. With Discovery, Oprah Winfrey, and Gary Vaynerchuk, her success came from diversifying revenue streams, adapting through consolidation, and managing through the digitization of the industry. She began her career in advertising sales before broadening into senior sales and marketing roles.`,
    bio2: `Ms. Mitchell holds a bachelor’s degree from Villanova University and lives in New York with her husband and two children.`,
    bio3: `Ms. Mitchell is a valuable member of our board of directors because of her management experience in the technology sector, including the management of digital assets such as cell towers, wireless easements and lease assignments, fiber networks, and edge computing.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      bio2={bioData.bio2}
      bio3={bioData.bio3}
      closeBio={props.closeBio}
    />
  );
};

export default KateMBio;
